import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Divider, IconButton, Modal, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { COLOR_RED, COLOR_PRIMARY } from 'src/utils/const';
import { ReportTypes } from '../../Pages/EstimatorPage/propTypes';

const REPORT_PATH_OPTIONS: { label: string; value: ReportTypes }[] = [
  { label: 'Investment Report', value: 'buy' },
  { label: 'Rental Arbitrage Report', value: 'rent' },
  { label: 'Property Management Report', value: 'manage' },
];

interface ExportExcelModalProps {
  open: boolean;
  onClose: () => void;
  onExport: (reportPath: ReportTypes) => void;
  currentReportType: ReportTypes;
}

const ExportExcelModal: React.FC<ExportExcelModalProps> = ({
  open,
  onClose,
  onExport,
  currentReportType,
}) => {
  const [reportPath, setReportPath] = useState<ReportTypes>(currentReportType);

  useEffect(() => {
    if (open) setReportPath(currentReportType);
  }, [open, currentReportType]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          border: 'none',
          outline: 'none',
          width: 'clamp(300px, 100%, 500px)',
          padding: '30px',
          borderRadius: '12px',
          background: '#fff',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: '4px',
            right: '4px',
          }}
        >
          <CloseRoundedIcon sx={{ color: COLOR_RED }} />
        </IconButton>

        <Typography variant="h6" sx={{ mb: 2, pr: 4 }}>
          Export to Excel
        </Typography>

        <Typography variant="h6" sx={{ mb: 2 }}>
          Report Type
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap', mb: 3 }}>
          {REPORT_PATH_OPTIONS.map(opt => (
            <Chip
              key={opt.value}
              label={opt.label}
              variant={reportPath === opt.value ? 'filled' : 'outlined'}
              onClick={() => setReportPath(opt.value)}
              sx={{
                fontWeight: 600,
                fontSize: '13px',
                ...(reportPath === opt.value
                  ? {
                      background: COLOR_PRIMARY,
                      color: '#fff',
                      '&:hover': { background: '#026b7d' },
                    }
                  : {
                      borderColor: '#d1d5db',
                      color: '#4b5563',
                      '&:hover': { background: '#f3f4f6' },
                    }),
              }}
            />
          ))}
        </Box>

        <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={onClose} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => onExport(reportPath)}
            sx={{
              textTransform: 'none',
              background: COLOR_PRIMARY,
              '&:hover': { background: COLOR_PRIMARY },
            }}
          >
            Export
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExportExcelModal;
